import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";


const LoginPage = ({ handleLogin, setAuthMode, loginError }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(email, password);
  };

  return (
    <>
      {/* Header Section */}
      <div className="header">
        <Link to="/" className="auth-header">Auden AI</Link>
      </div>

      {/* Login Form Section */}
      <div className="auth-container">
        <div className="auth-card">
          <h2>Login</h2>
          {loginError && <p className="error-message">{loginError}</p>}
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="input-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="auth-button">Login</button>
          </form>
          <p>
            Don't have an account?{" "}
            <button className="switch-auth" onClick={() => navigate("/register")}>
              Register Here
            </button>
          </p>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
